export class UserActivityTracker {
    constructor(userActivityTrackingIntervalTime, trackUserActivityAsync, updateWhenUserActive, windowFocus) {
        this.userActivityTrackingIntervalTime = userActivityTrackingIntervalTime;
        this.trackUserActivityAsync = trackUserActivityAsync;
        this.updateWhenUserActive = updateWhenUserActive;
        this.windowFocus = windowFocus;
        this.lastClientX = 0;
        this.lastClientY = 0;
        // Binding methods to ensure the correct `this` context
        this.onMouseMove = this.onMouseMove.bind(this);
        this.updateWhenUserActive = this.updateWhenUserActive.bind(this);
        this.windowFocus = this.windowFocus.bind(this);
    }
    init() {
        if (!this.userActivityTrackingInterval) {
            this.userActivityTrackingInterval = window.setInterval(async () => {
                await this.trackUserActivityAsync();
            }, this.userActivityTrackingIntervalTime);
        }
        window.addEventListener('focus', () => this.windowFocus());
        window.addEventListener('mousemove', this.onMouseMove);
        window.addEventListener('touchstart', this.updateWhenUserActive);
        window.addEventListener('click', this.updateWhenUserActive);
        window.addEventListener('keydown', this.updateWhenUserActive);
    }
    clear() {
        window.clearInterval(this.userActivityTrackingInterval);
        window.removeEventListener('focus', this.windowFocus);
        window.removeEventListener('mousemove', this.onMouseMove);
        window.removeEventListener('touchstart', this.updateWhenUserActive);
        window.removeEventListener('click', this.updateWhenUserActive);
        window.removeEventListener('keydown', this.updateWhenUserActive);
    }
    onMouseMove(e) {
        if (this.lastClientX !== e.clientX || this.lastClientY !== e.clientY) {
            // because webkit keeps on firing the event if cursor is in page
            this.updateWhenUserActive();
        }
        this.lastClientX = e.clientX;
        this.lastClientY = e.clientY;
    }
}
